import React from 'react'
import { connect } from 'react-redux'
import {
    getUserType,
    getImpersonatedBy,
    isEmserUser,
    getIsAdmin,
    getUserName,
    canViewRocketPromotion,
    getNaturalStoneViewingPermissions,
    canViewSilestoneContainerPromotion,
    isUserDistributor,
    canViewSilestonePromotion,
    isPriorityCustomerForEclos,
    requiredAdvancePayment
} from '../store/login/reducers'
import {
    getIsLowesCenter,
    getIsMkToolsCenter,
    getIsIkeaCenter,
    getIsEndiCenter,
    canOffer,
    getShippingMethod,
    getSelectedCenter,
    getHasMinWeight,
    getCoin,
    isLatinaVitoria,
    isDisabledPreferedDeliveryDatePicker,
    isUsaOrCanada,
    isOnlyUsaSalesOrg,
    getDRIUSACenterId,
    getDriUsaOrderLimit,
    isSelectedCenterAvailableToBuyEclosProducts
} from '../store/centers/reducers'
import CheckoutV2 from '../components/checkout/CheckoutV2'
import {
    getLanguage,
    getLanguageDir,
    getCheckoutStep,
    getLocalizedUrl,
    getBlockOrdersFromMktoolsDriUsa,
    canViewEclosBrandInEurope,
    canViewDektonArtikPromotion
} from '../store/ui/reducers'
import {
    getCalculatingLinesPrice,
    getFinishStep,
    getGoalMax,
    getGoalMin,
    getIsValidVoucher,
    getKgPoundRatio,
    getLines,
    getReservationCode,
    getTransformingSkuToLots,
    isSending,
    qtySelector,
    totalCoin,
    totalSelector,
    weightSelector,
    getIsLoading,
    getReservationCutToSizeCode,
    getReservationConfigurableCode,
    totalSelectorMktools,
    getReservationQuickShipConfigurableCode,
    getReservationQuickShipConfigurableCodes,
    getFullUnits,
    subtotalSelector,
    getReservationShippingAddressType
} from '../store/cart/reducers'
import {
    canSendCheckoutSaleConditions,
    canSendCheckoutHealthConditions,
    getComments,
    getDeliveryDate,
    getDestination,
    getIkeaTransportArea,
    getInstallationDataAddress,
    getInstallationDataName,
    getInstallationDataPhone,
    getInstallationDataProvince,
    getInstallationDataTown,
    getInstallationDataZipCode,
    getLowesDataEmail,
    getLowesDataFirstName,
    getLowesDataLastName,
    getLowesDataTitle,
    getMinRequiredDate,
    getPo,
    getSaleConditionsCheck,
    getHealthConditionsCheck,
    getSelectedShippingAddress,
    getIsVirtualVisitMandatorySfId, getUseOldHealthConditionsWorkflow
} from '../store/checkout/reducers'
import { getCurrentCrossSelling, getCurrentCrossSellingCheckout } from '../store/crossSelling/reducers'
import { addCartLine, checkout, emptyCart, transformSkuToLots, isCheckoutPageScreen } from '../store/cart/actions'
import { fetchCrossSellingCheckOut } from '../store/crossSelling/actions'
import {
    canSendLowesData,
    canSendMinMaxCheckout,
    canSendNeedDestination,
    setComments,
    setDeliveryDate, setDestination,
    setHasSelectedCenter, setSelectedShippingAddressId,
    setStep,
    setCheckoutStepOneButtonNextDisabled
} from '../store/checkout/actions'
import { getProfileConfiguration } from '../store/profile-configuration/reducers'
import { getEmployeeId } from '../store/big-account/reducers'
import { dispatchPushURL } from '../store/ui/actions'
import {
    getSelectedShippingAddressForIkea, getSelectedShippingCenter,
    getShippingAddresses
} from '../store/shipping-addresses/reducers'
import {injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";
import { fetchFastDeliveryTimes } from '../store/cut-to-size/actions'
import { canSeeEclosVoucher, eclosVoucherCode } from '../store/vouchers/reducers'

const mapStateToProps = (state, props) => {
    let language = getLanguage(state)
    let defaultUnit = language === 'en' || language === 'en-US' || language === 'fr-CA' ? 'LB' : 'KG'
    let unit = getProfileConfiguration(state).weightUnit ? getProfileConfiguration(state).weightUnit : defaultUnit

    return {
        languageDir: getLanguageDir(state),
        isEndiCenter: getIsEndiCenter(state),
        isOffer: canOffer(state),
        total: totalSelector(state),
        subtotal: subtotalSelector(state),
        totalMktools: totalSelectorMktools(state),
        coinMktools: getCoin(state),
        coin: totalCoin(state),
        lang: getLanguage(state),
        calculatingLinesPrice: getCalculatingLinesPrice(state),
        totalQty: qtySelector(state),
        hasSaleConditionsCheck: getSaleConditionsCheck(state),
        hasHealthConditionsCheck: getHealthConditionsCheck(state),
        useOldHealthConditionsWorkflow: getUseOldHealthConditionsWorkflow(state),
        crossSelling: getCurrentCrossSelling(state),
        crossSellingCheckout: getCurrentCrossSellingCheckout(state),
        shippingMethod: getShippingMethod(state),
        lines: getLines(state),
        userType: getUserType(state),
        impersonatedBy: getImpersonatedBy(state),
        isLowesCenter: getIsLowesCenter(state),
        isMktoolsCenter: getIsMkToolsCenter(state),
        isIkeaCenter: getIsIkeaCenter(state),
        isValidVoucher: getIsValidVoucher(state),
        isSending: isSending(state),
        canSendCheckoutSaleConditions: canSendCheckoutSaleConditions(state),
        canSendCheckoutHealthConditions: canSendCheckoutHealthConditions(state),
        transformingSkuToLots: getTransformingSkuToLots(state),
        isEmserUser: isEmserUser(state),
        po: getPo(state),
        finishStep: getFinishStep(state),
        reservationCode: getReservationCode(state),
        reservationCutToSizeCode: getReservationCutToSizeCode(state),
        reservationConfigurableCode: getReservationConfigurableCode(state),
        reservationQuickShipConfigurableCode: getReservationQuickShipConfigurableCode(state),
        quickShipReservations: getReservationQuickShipConfigurableCodes(state),
        hasDestination: getShippingMethod(state) === 'CONTAINER',
        destination: getDestination(state),
        selectedShippingAddress: getSelectedShippingAddress(state),
        deliveryDate: getDeliveryDate(state),
        minDeliveryDate: getMinRequiredDate(state),
        centerSelected: getSelectedCenter(state),
        current: unit === 'KG' ? weightSelector(state) : Math.floor(weightSelector(state) * getKgPoundRatio()),
        goalMin: getGoalMin(state, unit),
        goalMax: getGoalMax(state, unit),
        hasMinWeight: getHasMinWeight(state),
        isAdmin: getIsAdmin(state),
        employeeId: getEmployeeId(state),
        ikeaTransportArea: getIkeaTransportArea(state),
        userName: getUserName(state),
        installationDataName: getInstallationDataName(state),
        installationDataAddress: getInstallationDataAddress(state),
        installationDataTown: getInstallationDataTown(state),
        installationDataProvince: getInstallationDataProvince(state),
        installationDataZipCode: getInstallationDataZipCode(state),
        installationDataPhone: getInstallationDataPhone(state),
        comments: getComments(state),
        shippingAddresses: getShippingAddresses(state),
        ikeaSelectedShippingAddress: getSelectedShippingAddressForIkea(state),
        lowesDataFirstName: getLowesDataFirstName(state),
        lowesDataLastName: getLowesDataLastName(state),
        lowesDataEmail: getLowesDataEmail(state),
        lowesDataTitle: getLowesDataTitle(state),
        currentStep: getCheckoutStep(state),
        isLoading: getIsLoading(state),
        canViewRocketPromotion: canViewRocketPromotion(state),
        extendedPath: (filter) => getLocalizedUrl(state, props.intl, 'ROUTE_CHECKOUT') + '/' + filter,
        history: props.history,
        isLatinaVitoria: isLatinaVitoria(state),
        isDisabledPreferedDeliveryDatePicker: isDisabledPreferedDeliveryDatePicker(state),
        naturalStoneViewingPermissions: getNaturalStoneViewingPermissions(state),
        isChangingCartQty: state.cart.isChangingCartQty,
        isUsaOrCanada: isUsaOrCanada(state),
        isOnlyUsaSalesOrg: isOnlyUsaSalesOrg(state),
        isMandatorySfId: getIsVirtualVisitMandatorySfId(state),
        canViewSilestoneContainerPromotion: canViewSilestoneContainerPromotion(state),
        selectedShippingCenter: getSelectedShippingCenter(state),
        isDistributor: isUserDistributor(state),
        canViewSilestonePromotion: canViewSilestonePromotion(state),
        driUsaCenterId: getDRIUSACenterId(),
        driUsaOrderLimit: getDriUsaOrderLimit(state),
        getBlockOrdersFromMktoolsDriUsa: getBlockOrdersFromMktoolsDriUsa(state),
        isPriorityCustomerForEclos: isPriorityCustomerForEclos(state),
        canViewEclosBrandInEurope: canViewEclosBrandInEurope(state),
        fullUnits: getFullUnits(state),
        unit: unit,
        requiredAdvancePayment: requiredAdvancePayment(state),
        isSelectedCenterAvailableToBuyEclosProducts: isSelectedCenterAvailableToBuyEclosProducts(state),
        canViewDektonArtikPromotion: canViewDektonArtikPromotion(state),
        reservationShippingAddressType: getReservationShippingAddressType(state),
        eclosVoucherCode: eclosVoucherCode(state),
        canSeeEclosVoucher: canSeeEclosVoucher(state)
    }
}

const mapDispatchToProps = (dispatch, props) => {
    return {
        addCartLine: (product, qty, extra, callbackCenter, dektonGripRequested) => {
            dispatch(addCartLine(product, qty, extra, callbackCenter, dektonGripRequested))
        },
        fetchCrossSelling: productIds => {
            return dispatch(fetchCrossSellingCheckOut(productIds))
        },
        canSendMinMaxCheckout: () => dispatch(canSendMinMaxCheckout()),
        canSendNeedDestination: () => dispatch(canSendNeedDestination()),
        submitCheckoutFormCustomer: () => dispatch(checkout(true)),
        submitCheckoutFormMktools: () => dispatch(checkout()),
        submitCheckoutFormIkea: () => dispatch(checkout()),
        submitCheckout: () => dispatch(checkout()),
        transformSkuToLots: () => {
            return dispatch(transformSkuToLots())
        },
        setDeliveryDate: value => dispatch(setDeliveryDate(value)),
        setHasSelectedCenter: value => dispatch(setHasSelectedCenter(value)),
        setSelectedShippingAddressId: value => dispatch(setSelectedShippingAddressId(value)),
        setDestination: value => dispatch(setDestination(value)),
        setComments: value => dispatch(setComments(value)),
        setStep: value => dispatch(setStep(value)),
        goCatalog: intl => {
            dispatch(dispatchPushURL(intl.formatMessage({ id: 'ROUTE_CATALOG' }).replace(':outlet?', '')))
            dispatch({ type: 'REMEMBER_CENTER' })
        },
        canSendLowesData: () => dispatch(canSendLowesData()),
        emptyCart: () => {
            dispatch({ type: 'EMPTY_CART_BY_USER' })
            dispatch(emptyCart())
        },
        redirect: url => {
            dispatch(dispatchPushURL(url))
        },
        setIsCheckoutPage: (isCheckoutPage) => dispatch(isCheckoutPageScreen(isCheckoutPage)),
        setCheckoutStepOneButtonNextDisabled: (checkoutStepOneButtonNextDisabled) => dispatch(setCheckoutStepOneButtonNextDisabled(checkoutStepOneButtonNextDisabled)),
        fetchFastDeliveryTimes: () => dispatch(fetchFastDeliveryTimes())
    }
}

export default withRouter(injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutV2)))
